import React from 'react'
import { Row, Col } from 'reactstrap'
import RedirectButton from 'components/atoms/redirect-button'
import { DisabledBannerOverlay } from 'components/atoms'
import PropTypes from 'prop-types'

const propTypes = {
  subBanners: PropTypes.array
}

const defaultProps = {
  subBanners: []
}

const CmsLuxurySectionSubBanners = ({ subBanners }) => {
  //index for wider sub promo's image (index start from 0)
  const widerPromoPositions = [ 1, 3 ]

  //set sub promo's image width
  const promoWidth = (index) => {
    const isWider = widerPromoPositions.find((element) => element === index)
    const colSize = isWider ? '6' : '3'
    return colSize
  }

  const isImgBlur = (subBanner) => !subBanner.is_active
    ? { filter: 'blur(3px)' }
    : {}

  const isActiveButton = (subBanner) => subBanner.image_url && subBanner.is_active
    ? 'primary'
    : 'warning'

  return (
    <Row>
      {
        subBanners.map((subBanner, index) => (
          <Col
            className='mb-3'
            key={ `sub-banner-${index}` }
            lg={ promoWidth(index) }
          >
            <DisabledBannerOverlay isActive={ subBanner.is_active } />
            <img
              src={ subBanner.image_url }
              alt={ subBanner.alt_text }
              width='100%'
              style={ isImgBlur(subBanner) }
            />
            <h4>{ subBanner.header_text }</h4>
            <h5>{ subBanner.caption_text }</h5>
            <RedirectButton
              text={ `Edit ${subBanner.name}` }
              path={ `sections/${subBanner.id}` }
              color={ isActiveButton(subBanner) }
              className='float-right mt-1'
              size='sm'
            />
          </Col>
        ))
      }
    </Row>
  )
}

CmsLuxurySectionSubBanners.propTypes    = propTypes
CmsLuxurySectionSubBanners.defaultProps = defaultProps

export default CmsLuxurySectionSubBanners
